import * as Yup from "yup";

const TCTemaCorporativoTemaCreateSchema = Yup.object({
    descricao: Yup.string().required({ name: "nome", err: "Campo com preenchimento obrigatório" }),
    id_tema_grupo: Yup.number().required({ name: "grupo", err: "Campo com preenchimento obrigatório" }),
});


export default TCTemaCorporativoTemaCreateSchema;